export const mockBotReplies = [
  { ar: 'أنا لسه بوت تجريبي 🙂 الدردشة الذكية الحقيقية جاية قريب!',
    en: "I'm just a demo bot for now 🙂 real AI chat is coming soon!" },
  { ar: 'تمام، سجّلت طلبك — هطوّر الميزة دي قريب!',
    en: "Got it, noted — I'll build that feature out soon!" },
  { ar: 'فكرة حلوة! هحطها في قايمة المهام 📝',
    en: 'Great idea, adding it to the list 📝' },
];
